import React, { useEffect, useContext } from 'react';
import { LayoutContext } from '../components/LayoutProvider';
import logo from '../images/tuutuum-logo-black.png';
import '../styles/styles.css';
import LanguageSwitcher from './LanguageSwitcher';

const NeumorphicContainer = ({ children }) => {
    return (
        <div className="flex flex-col items-center justify-center h-full w-full bg-gradient">
            {/* Logo */}
            <img src={logo} alt="Tuutuum Logo" className="block h-20 w-auto" />
            <div className="relative flex flex-col neumorp items-center justify-center space-y-3 bg-white px-6 py-10 sm:p-10 rounded-lg shadow-lg w-full max-w-xs sm:max-w-sm">
                {/* Language Switcher */}
                <div className="language-switcher">
                    <LanguageSwitcher />
                </div>
                {children}
            </div>
        </div>
    );
};

export default NeumorphicContainer;